import StatsAPI from "@/src/api/StatsAPI";

import type { Query } from "@/src/api/BaseAPI";
import type {
  GetUserWatchedGraphResponse,
  GetUserWatchedKPIResponse,
} from "@/src/api/StatsAPI.types";
import type { AnalyticsPeriod } from "@/src/hooks/usePeriodFilter";

export function userWatchedGraphQuery(
  projectSlug: string,
  userUuid: string,
  { startDate, endDate }: AnalyticsPeriod,
): Query<GetUserWatchedGraphResponse> {
  return StatsAPI.generateQuery({
    fn: StatsAPI.getUserWatchedGraph,
    params: [
      {
        userId: userUuid,
        periodStart: startDate,
        periodEnd: endDate,
        projectSlug,
      },
    ],
    options: { keepPreviousData: true },
  });
}

export function userWatchedKpiQuery(
  projectSlug: string,
  userUuid: string,
): Query<GetUserWatchedKPIResponse> {
  return StatsAPI.generateQuery({
    fn: StatsAPI.getUserWatchedKPI,
    params: [{ userId: userUuid, projectSlug }],
  });
}
